import { ColumnDecoration, DataTableColumn } from 'components/dataTable';

import i18next from 'locales/i18next';

const { t } = i18next;

export const LABELS = {
  PANEL_TITLE: ['components.accountSettings.apiKeys.title', 'API Keys'],
  CREATE_BUTTON: ['components.accountSettings.apiKeys.createButton', 'CREATE API KEY'],
  ACCESS_DENIED: ['components.accountSettings.apiKeys.accessDenied', "You don't have access to manage API keys for this account."],
  EMPTY_STATE: ['components.accountSettings.apiKeys.emptyState', 'No API keys yet'],
  ACTIONS: {
    TITLE: ['components.accountSettings.apiKeys.actions.title', 'Actions'],
    EDIT: ['components.accountSettings.apiKeys.actions.edit', 'Edit'],
    DELETE: ['components.accountSettings.apiKeys.actions.delete', 'Delete'],
  },
  TABLE_COLUMNS: {
    NAME: ['components.accountSettings.apiKeys.table.columns.name', 'Name'],
    SECRET_KEY: ['components.accountSettings.apiKeys.table.columns.secretKey', 'Secret Key'],
    CREATED_AT: ['components.accountSettings.apiKeys.table.columns.createdAt', 'Created At'],
    CREATED_BY: ['components.accountSettings.apiKeys.table.columns.createdBy', 'Created By'],
    LAST_USED_AT: ['components.accountSettings.apiKeys.table.columns.lastUsedAt', 'Last Used At'],
    WHITELIST: ['components.accountSettings.apiKeys.table.columns.whitelist', 'Whitelist'],
    ACTIONS: ['components.accountSettings.apiKeys.table.columns.actions', ''],
  },
  MODAL: {
    CREATE_TITLE: ['components.accountSettings.apiKeys.modal.createTitle', 'Create API Key'],
    EDIT_TITLE: ['components.accountSettings.apiKeys.modal.editTitle', 'Edit API Key'],
    NAME: {
      TITLE: ['components.accountSettings.apiKeys.modal.name.title', 'Name'],
      PLACEHOLDER: ['components.accountSettings.apiKeys.modal.name.placeholder', 'Production key'],
    },
    WHITELIST: {
      TITLE: ['components.accountSettings.apiKeys.modal.whitelist.title', 'Whitelisted IPs'],
      PLACEHOLDER: ['components.accountSettings.apiKeys.modal.whitelist.placeholder', '192.168.1.1, 10.0.0.*'],
      HINT: ['components.accountSettings.apiKeys.modal.whitelist.hint', 'Comma or newline separated. Leave blank to allow all IPs.'],
    },
    BUTTONS: {
      CANCEL: ['components.accountSettings.apiKeys.modal.buttons.cancel', 'Cancel'],
      CONFIRM: ['components.accountSettings.apiKeys.modal.buttons.confirm', 'Confirm'],
      DONE: ['components.accountSettings.apiKeys.modal.buttons.done', 'Done'],
    },
    REVEAL: {
      TITLE: ['components.accountSettings.apiKeys.modal.reveal.title', 'API Key Created'],
      WARNING: ['components.accountSettings.apiKeys.modal.reveal.warning', 'Copy the secret key now — it will not be shown again.'],
      SECRET_KEY: ['components.accountSettings.apiKeys.modal.reveal.secretKey', 'Secret Key'],
      COPIED: ['components.accountSettings.apiKeys.modal.reveal.copied', 'Copied to clipboard'],
    },
  },
  DELETE_MODAL: {
    TITLE: ['components.accountSettings.apiKeys.deleteModal.title', 'Delete API Key'],
    QUESTION: ['components.accountSettings.apiKeys.deleteModal.question', 'Are you sure?'],
    CAPTION: [
      'components.accountSettings.apiKeys.deleteModal.caption',
      'Delete {{name}}. Any integration using this key will stop working immediately.',
    ],
    SUCCESS: ['components.accountSettings.apiKeys.deleteModal.success', 'API key deleted.'],
    BUTTONS: {
      CANCEL: ['components.accountSettings.apiKeys.deleteModal.buttons.cancel', 'Cancel'],
      CONFIRM: ['components.accountSettings.apiKeys.deleteModal.buttons.confirm', 'Delete'],
    },
  },
};

export const COLUMN_IDS = {
  ID: 'uuid',
  NAME: 'name',
  SECRET_KEY: 'secretKey',
  CREATED_AT: 'createdAt',
  CREATED_BY: 'createdBy',
  LAST_USED_AT: 'lastUsedAt',
  WHITELIST: 'whitelist',
  ACTIONS: 'actions',
} as const;

export const COLUMNS: DataTableColumn[] = [
  { id: COLUMN_IDS.NAME, label: t(LABELS.TABLE_COLUMNS.NAME), decoration: ColumnDecoration.bold },
  { id: COLUMN_IDS.SECRET_KEY, label: t(LABELS.TABLE_COLUMNS.SECRET_KEY) },
  { id: COLUMN_IDS.CREATED_AT, label: t(LABELS.TABLE_COLUMNS.CREATED_AT) },
  { id: COLUMN_IDS.CREATED_BY, label: t(LABELS.TABLE_COLUMNS.CREATED_BY) },
  { id: COLUMN_IDS.LAST_USED_AT, label: t(LABELS.TABLE_COLUMNS.LAST_USED_AT) },
  { id: COLUMN_IDS.WHITELIST, label: t(LABELS.TABLE_COLUMNS.WHITELIST) },
  { id: COLUMN_IDS.ACTIONS, label: t(LABELS.TABLE_COLUMNS.ACTIONS) },
];
